<template>
  <div class="login-container">
    <div class="login-form">
      <h1 class="site-name">清一公社家园</h1>
      <h2>用户登录</h2>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="username">用户名:</label>
          <input type="text" id="username" v-model="user.username" required>
        </div>
        <div class="form-group">
          <label for="password">密码:</label>
          <input type="password" id="password" v-model="user.password" required>
        </div>
        <button type="submit" :disabled="loading">
          {{ loading ? '登录中...' : '登录' }}
        </button>
      </form>
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { authService } from '../services/authService'

export default {
  name: 'UserLogin',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      errorMessage: '',
      loading: false
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      this.errorMessage = ''
      
      try {
        const response = await authService.login(this.user)
        
        if (response.success) {
          const userData = {
            token: response.data.accessToken,
            id: response.data.id,
            username: response.data.username,
            email: response.data.email,
            role: response.data.role,
            tokenType: response.data.tokenType
          }
          
          localStorage.setItem('user', JSON.stringify(userData))
          
          // 获取用户的首个可访问页面
          const { permissionService } = await import('@/services/permissionService')
          const firstPage = await permissionService.getFirstAccessiblePage()
          this.$router.push(firstPage)
        } else {
          this.errorMessage = response.message || '登录失败'
        }
      } catch (error) {
        console.error('Login error:', error)
        console.error('Error response:', error.response)
        
        if (error.response) {
          const { status, data } = error.response
          
          if (status === 401) {
            // 401错误通常是用户名或密码错误
            this.errorMessage = data?.message || '用户名或密码错误'
          } else if (status === 403) {
            this.errorMessage = '访问被拒绝，请联系管理员'
          } else if (status === 404) {
            this.errorMessage = '登录服务不可用，请联系管理员'
          } else if (status >= 500) {
            this.errorMessage = '服务器错误，请稍后重试'
          } else {
            this.errorMessage = data?.message || '登录失败，请检查用户名和密码'
          }
        } else if (error.request) {
          this.errorMessage = '网络连接失败，请检查网络设置'
        } else {
          this.errorMessage = '登录失败，请重试'
        }
        
        authService.logout()
      } finally {
        this.loading = false
      }
    },
    async redirectIfAuthenticated() {
      // 如果已经登录，跳转到首个可访问页面
      if (authService.isAuthenticated()) {
        const { permissionService } = await import('@/services/permissionService')
        const firstPage = await permissionService.getFirstAccessiblePage()
        this.$router.push(firstPage)
      }
    }
  },
  async mounted() {
    await this.redirectIfAuthenticated()
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-form {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 300px;
}

.site-name {
  margin: 0 0 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
}

.login-form h2 {
  margin: 0 0 1.25rem;
  font-size: 1.1rem;
  font-weight: 500;
  color: #666;
  text-align: center;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

button {
  width: 100%;
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

button:hover {
  background-color: #0056b3;
}

.error-message {
  color: red;
  margin-top: 1rem;
}
</style>